"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var react_1 = __importStar(require("react"));
var FileInput_1 = require("./FileInput");
/**
 * A simple button, with a possibility to be used as a file upload button
 *
 * @param {object} buttons The list of buttons to display (object with a label and a payload)
 * @param {function} onButtonClicked Called when the button is clicked with the label and the payload
 * @param {function} onFileUpload This is called when a file is uploaded
 */
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button(props) {
        var _this = _super.call(this, props) || this;
        _this.handleButtonClick = function (e) {
            var _a, _b;
            if (_this.props.preventDoubleClick) {
                e.target.disabled = true;
            }
            (_b = (_a = _this.props).onButtonClick) === null || _b === void 0 ? void 0 : _b.call(_a, _this.props.label, _this.props.payload);
        };
        _this.handleFileUpload = function (event) {
            var _a, _b;
            if (!event.target.files) {
                return;
            }
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (_b = (_a = _this.props).onFileUpload) === null || _b === void 0 ? void 0 : _b.call(_a, _this.props.label, _this.props.payload, event.target.files[0]);
        };
        return _this;
    }
    Button.prototype.renderFileUpload = function (accept) {
        return (react_1.default.createElement("button", { className: 'bpw-button bpw-file-button' },
            react_1.default.createElement(FileInput_1.FileInput, { name: 'uploadField', accept: accept, className: 'bpw-file-message', placeholder: this.props.label, onFileChanged: this.handleFileUpload }),
            react_1.default.createElement("span", null, this.props.label)));
    };
    Button.prototype.render = function () {
        if (this.props.payload === 'BOTPRESS.IMAGE_UPLOAD') {
            return this.renderFileUpload('image/*');
        }
        if (this.props.payload === 'BOTPRESS.FILE_UPLOAD') {
            return this.renderFileUpload('*/*');
        }
        return (react_1.default.createElement("button", { className: 'bpw-button', onClick: this.handleButtonClick }, this.props.label));
    };
    return Button;
}(react_1.Component));
exports.Button = Button;
